import { Button } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";

interface StarRatingProps {
    initialRating: number;
    onRatingChange: (ratingValue: number) => void;
}

const StarRating = ({ initialRating, onRatingChange }: StarRatingProps) => {
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);

    useEffect(() => {
        setRating(initialRating);
    }, [initialRating]);

    const handleRating = (index: number) => {
        setRating(index);
        onRatingChange(index);
    };

    return (
      <div className="star-rating">
        {[...Array(5)].map((star, index) => {
          index += 1;
          return (
            <Button
              type="button"
              key={index}
              sx={{
                backgroundColor: 'transparent',
                border: 'none',
                outline: 'none',
                cursor: 'pointer',
                width: '50px',
                height: '50px',
                color: index <= (hover || rating) ? '#ccc' : '#000',
              }}
              onClick={() => handleRating(index)}
              onMouseEnter={() => setHover(index)}
              onMouseLeave={() => setHover(rating)}
            >
              <span className="star">&#9733;</span>
            </Button>
          );
        })}
      </div>
    );
};

export default StarRating ;